// extracted by mini-css-extract-plugin
export var assigneeBadge = "_iq-0";
export var assigneeDetails = "_iq-1";
export var assigneeInfo = "_iq-2";
export var dropdownContainer = "_iq-4";
export var dropdownImage = "_iq-5";
export var editAssigneeInfo = "_iq-3";
export var editAssigneeModalContainer = "_iq-6";
export var hidden = "_iq-8";
export var input = "_iq-7";